import Camera, { FACING_MODES, IMAGE_TYPES } from './Camera';

export {
  FACING_MODES,
  IMAGE_TYPES
};

export default Camera;



// WEBPACK FOOTER //
// ./src/lib/components/index.js